import { createFileRoute } from "@tanstack/react-router"

import { HelpRouteComponent } from "@/routes/help"

export const Route = createFileRoute("/qr/$qrLookupID/help")({
  component: HelpRouteComponent,
})
